import { RSAA } from 'redux-api-middleware';
import url from 'url';
import { selectors } from 'app-webtech-core/selectors';
import prependApiBaseUrl from '../helpers/prependApiBaseUrl';

const injectStateParams = (endpoint, state) => {
  const parsedEndpoint = url.parse(endpoint, true);
  const stitcherParams = selectors.application.stitcherParams(state);
  parsedEndpoint.search = undefined;

  if (Object.keys(stitcherParams).length !== 0) {
    parsedEndpoint.query = {
      ...parsedEndpoint.query,
      ...stitcherParams,
      ...{ attributeV4: 'foo' },
    };
    return url.format(parsedEndpoint);
  }

  const deviceApiParams = selectors.device.apiParams(state);
  const playbackSessionApiParams = selectors.playbackSession.apiParams(state);
  const applicationApiParams = selectors.application.apiParams(state);
  parsedEndpoint.query = {
    ...parsedEndpoint.query,
    ...deviceApiParams,
    ...playbackSessionApiParams,
    ...applicationApiParams,
    serverSideAds: true,
  };
  return url.format(parsedEndpoint);
};

export const prepareEndpointWithState = (endpoint, state, keepProtocol) =>
  injectStateParams(prependApiBaseUrl(endpoint, keepProtocol, state), state);

const prepareEndpoint = (endpoint, store, injectParams) =>
  injectParams
    ? injectStateParams(prependApiBaseUrl(endpoint, null, store.getState()), store.getState())
    : prependApiBaseUrl(endpoint, null, store.getState());

const prepareHeaders = (endpoint, headers = {}, authorization, store) => {
  let credentials = {};
  const state = store.getState();
  const { sessionToken } = state.application
    ? state.application
    : { sessionToken: false, setup: { servers: { stitcher: '' } } };

  const shouldIncludeAuthorizationHeader =
    process.env.HEADER_JWT_ENABLED === 'true' &&
    process.env.BOOTSTRAP_VERSION === 'v4' &&
    sessionToken;
  if (authorization) credentials = selectors.userAccount.credentials(state);

  return {
    'Content-Type': 'application/json',
    ...(shouldIncludeAuthorizationHeader ? { Authorization: `Bearer ${sessionToken}` } : {}),
    ...credentials,
    ...headers,
  };
};

const prepareBody = (body) => {
  let result = body;
  if (body) {
    result = JSON.stringify(body);
  }
  return result;
};

export const plutoApiInjectorMiddleware = (store) => (next) => (action) => {
  let newAction = action;

  if (action[RSAA]) {
    const {
      authorization = true,
      endpoint,
      headers,
      body,
      injectParams = true,
      ...actionProperties
    } = action[RSAA];

    newAction = {
      ...action,
      [RSAA]: {
        ...actionProperties,
        endpoint: prepareEndpoint(endpoint, store, injectParams),
        headers: prepareHeaders(endpoint, headers, authorization, store),
        body: prepareBody(body),
      },
    };
  }
  return next(newAction);
};
